export enum ColorSchemes {
  PRIMARY = 'primary',
  OFFERS = 'offers'
}
